import { useEffect, useState } from "react"
import availableAssets from "../data/vizagAssets.json"

const suppliedAssets = new Set(availableAssets)
export const availableAsset = (src) => suppliedAssets.has(src) ? src : undefined

export function availableImageAsset(src) {
  if (!src) return undefined
  const base = src.replace(/\.(png|jpe?g|webp)$/i, "")
  const candidates = [src, ...["png", "jpg", "jpeg", "webp"].map((extension) => `${base}.${extension}`)]
  return candidates.map(availableAsset).find(Boolean)
}

// Only mount an image for an asset included in the build; fall back on runtime failure too.
export function SpeakerPortrait({ speaker, className = "" }) {
  const src = availableAsset(speaker.image)
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])
  const initials = speaker.name.split(/\s+/).map((word) => word[0]).slice(0, 2).join("")
  return src && !failed ? (
    <img src={src} alt={speaker.name} loading="lazy" onError={() => setFailed(true)} className={`object-cover rounded-xl ${className}`} />
  ) : (
    <span role="img" aria-label={`${speaker.name} — photo coming soon`} className={`inline-flex shrink-0 items-center justify-center rounded-xl border border-green-200 bg-green-50 font-semibold text-green-800 ${className}`}>
      {initials}
    </span>
  )
}

export function PresentationVideo({ session }) {
  const src = availableAsset(session.video)
  const poster = availableImageAsset(session.image)
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])
  return src && !failed ? (
    <video key={src} src={src} poster={poster} controls playsInline preload="metadata" onError={() => setFailed(true)} aria-label={`${session.title} — presentation video`} className="w-full rounded-xl bg-green-50" style={{ filter: "none" }} />
  ) : (
    <>
      <PresentationThumbnail session={session} />
      <p className="rounded-lg border border-green-100 bg-green-50 px-5 py-4 text-sm text-green-700">Video coming soon</p>
    </>
  )
}

export function PresentationThumbnail({ session }) {
  const src = availableImageAsset(session.image)
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])
  if (!src || failed) return null
  return <img src={src} alt={session.title} loading="lazy" onError={() => setFailed(true)} className="mb-5 aspect-video w-full rounded-lg border border-green-100 object-cover" />
}
